import {spawnSync} from 'node:child_process';

import chalk from 'chalk';
import {Command} from 'commander';
import inquirer from 'inquirer';

import {initBackend} from './actions/init-backend';
import {initFrontend} from './actions/init-frontend';
import {initMobile} from './actions/init-mobile';

type ProjectType = 'backend' | 'frontend' | 'mobile';

interface CLIOptions {
  init?: ProjectType;
  template_name?: string;
  doctor?: boolean;
}

const program = new Command();

program
  .name('miregen')
  .description('Miregen CLI for generating project templates')
  .version('1.2.3', '-v, --version', 'Show CLI version')
  .option('--init <type>', 'Initialize a project type: backend|frontend|mobile')
  .option('--template_name <name>', 'Select a specific template')
  .option('--doctor', 'Check your environment setup');

program.parse(process.argv);
const options = program.opts<CLIOptions>();

const runDoctor = (): void => {
  spawnSync('node', ['-v'], {stdio: 'inherit'});
  spawnSync('npm', ['-v'], {stdio: 'inherit'});
};

const showMenu = async (): Promise<void> => {
  const {action} = await inquirer.prompt<{action: string}>([
    {
      choices: [
        'Backend',
        'Frontend',
        'Mobile',
        new inquirer.Separator(),
        chalk.green('Doctor'),
        chalk.blue('Version')
      ],
      message: 'Select an option:',
      name: 'action',
      type: 'list'
    }
  ]);

  switch (action) {
    case 'Backend':
      await initBackend();
      break;
    case 'Frontend':
      await initFrontend();
      break;
    case 'Mobile':
      await initMobile();
      break;
    case chalk.green('Doctor'):
      runDoctor();
      break;
    case chalk.blue('Version'):
      process.stdout.write(chalk.blue('Miregen CLI version 1.2.3\n'));
      break;
    default:
      process.stderr.write(chalk.red('Invalid selection\n'));
      break;
  }
};

// CLI direct usage
const runDirect = async (): Promise<void> => {
  if (options.init) {
    const type = options.init.toLowerCase() as ProjectType;

    if (!['backend', 'frontend', 'mobile'].includes(type)) {
      process.stderr.write(chalk.red('Invalid project type! Use backend|frontend|mobile\n'));
      process.exit(1);
    }

    switch (type) {
      case 'backend':
        await initBackend();
        break;
      case 'frontend':
        await initFrontend();
        break;
      case 'mobile':
        await initMobile();
        break;
      default:
        process.stderr.write(chalk.red('Unknown project type\n'));
        break;
    }
  } else if (options.doctor) {
    runDoctor();
  } else {
    await showMenu();
  }
};

runDirect().catch((err) => {
  process.stderr.write(
    chalk.red(`CLI error: ${err instanceof Error ? err.message : String(err)}\n`)
  );
  process.exit(1);
});
